import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ViewLogin = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  // The maps app URL — change for local dev
  const MAPS_URL = process.env.REACT_APP_MAPS_URL || 'https://maps.vestadesigns.com.au';
  const LOGIN_ACTION = `${MAPS_URL}/api/auth/login`;

  // Check for ?error=invalid in URL (redirect back from failed login)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('error') === 'invalid') {
      setError(true);
    }
  }, []);

  const handleSubmit = () => {
    setLoading(true);
  };

  return (
    <div className="portal-page">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div
          className="portfolio-hero-bg"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1920&q=80)'
          }}
        />
        <div className="portfolio-hero-overlay" />
        <div className="container">
          <motion.div
            className="portfolio-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="portfolio-hero-title">Vesta View</h1>
          </motion.div>
        </div>
      </section>

      {/* Login Form Section */}
      <section className="view-login-section">
        <div className="container">
          <motion.div
            className="view-login-card"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="view-login-header">
              <div className="view-login-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                  <polyline points="10 17 15 12 10 7" />
                  <line x1="15" y1="12" x2="3" y2="12" />
                </svg>
              </div>
              <h2>Sign in to continue</h2>
              <p>Access the Planning Permits Map portal</p>
            </div>

            {error && (
              <motion.div
                className="view-login-error"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                transition={{ duration: 0.3 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                <span>Invalid email or password. Please try again.</span>
              </motion.div>
            )}

            {/* 
              Plain form POST — submits directly to the maps server.
              No CORS needed because the browser navigates to the action URL.
              On success, the server sets a session cookie and redirects back.
            */}
            <form
              action={LOGIN_ACTION}
              method="POST"
              onSubmit={handleSubmit}
              className="view-login-form"
            >
              {/* Hidden fields */}
              <input type="hidden" name="redirect" value={MAPS_URL} />
              <input type="hidden" name="loginUrl" value={window.location.origin + '/view'} />

              <div className="view-login-field">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="your@email.com"
                  onChange={() => setError(false)}
                />
              </div>

              <div className="view-login-field">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  autoComplete="current-password"
                  placeholder="Enter password"
                  onChange={() => setError(false)}
                />
              </div>

              <button
                type="submit"
                className="view-login-btn"
                disabled={loading}
              >
                {loading ? (
                  <span className="view-login-btn-loading">
                    <svg className="view-login-spinner" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                    </svg>
                    Signing in...
                  </span>
                ) : (
                  'Sign In'
                )}
              </button>
            </form>

            <div className="view-login-footer">
              <p>Authorised personnel only. Contact admin for access.</p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ViewLogin;
